// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"style_clearfix__Ky9IU"};